import VerofreshRecord from './VerofreshRecord'

class RouteProductDataQualityRecord extends VerofreshRecord {
  static get FLAG_QUALITY_UNASSESSED () { return 2 ** 0 }
  static get FLAG_START_TEMPERATURE_MODIFIED () { return 2 ** 1 }
  static get FLAG_ABNORMAL_START_TEMPERATURE () { return 2 ** 2 }

  hasFlag (flag) {
    return (this.flags & flag) === flag
  }
}

export default RouteProductDataQualityRecord
